// React
import axios from 'axios';

// Actions
import { BASE_URL, BACKOFFICE_SERVICE, SERVICE_VERSION } from './configuration';
import { BACKOFFICE_SERVICE_ENDPOINT } from './configuration/backoffice-service';

// Data
import { REGION } from '../data/idConstants';
import { regionDetails } from '../data/appConstants';


export const BACKOFFICE_SERVICE_URL = `${BASE_URL}/${BACKOFFICE_SERVICE}/${SERVICE_VERSION}`;
const SUPPLIER_DETAILS_PAGINATION_URL = BACKOFFICE_SERVICE_URL + BACKOFFICE_SERVICE_ENDPOINT.SUPPLIER_DETAILS_WITH_PAGINATION;
const ALL_SUPPLIER_DETAILS_URL = BACKOFFICE_SERVICE_URL + BACKOFFICE_SERVICE_ENDPOINT.ALL_SUPPLIER_DETAILS;




export const getAllSupplierDetails = () => {

  let region = process.env.REACT_APP_REGION;
  if(region === REGION.IN.CODE){
    region = regionDetails[0].regionCode;
  }
  
  return async (dispatch) => {
    dispatch({
      type: 'SET_LOADER',
      payload: true
    });
  return await axios({
      method: 'GET',
      url: `${ALL_SUPPLIER_DETAILS_URL}`,
      params: {
        regionCode: region
      }
    })
      .then((response) => {
        dispatch({
          type: 'SET_ALL_SUPPLIER_DETAILS',
          payload: response.data
        });
        dispatch({
          type: 'SET_LOADER',
          payload: false
        });
        return response.data;
      })
      .catch((error) => {
        dispatch({
          type: 'ERROR',
          error: error
        });
        dispatch({
          type: 'SET_LOADER',
          payload: false
        });
      });
  };
};

export const getAllSupplierDetailsWithPagination = (search, currentPage, pageSize) => {

  let region = process.env.REACT_APP_REGION;
  if(region === REGION.IN.CODE){
    region = regionDetails[0].regionCode;
  }
  
  return (dispatch) => {
    dispatch({
      type: 'SET_LOADER',
      payload: true
    });
    axios({
      method: 'GET',
      url: `${SUPPLIER_DETAILS_PAGINATION_URL}`,
      params: {
        page: currentPage,
        size: pageSize,
        regionCode: region,
        searchKey: search
      }
    })
      .then((response) => {
        dispatch({
          type: 'SET_SUPPLIER_LIST',
          payload: response.data
        });
        dispatch({
          type: 'SET_LOADER',
          payload: false
        });
      })
      .catch((error) => {
        dispatch({
          type: 'ERROR',
          error: error
        });
        dispatch({
          type: 'SET_LOADER',
          payload: false
        });
      });
  };
};

export const validateTaxIdentifier = (taxIdentifier, type, countryCode) => {
  return async (dispatch) => {
    dispatch({
      type: 'SET_LOADER',
      payload: true
    });

    return await axios({
      method: 'GET',
      url: `${BACKOFFICE_SERVICE_URL + BACKOFFICE_SERVICE_ENDPOINT.VALIDATE_TAX_IDENTIFIER}`,
      params: {
        taxIdentifier: taxIdentifier,
        taxIdentifierType: type,
        countryCode: countryCode
      }
    })
      .then((response) => {
        dispatch({
          type: 'SET_LOADER',
          payload: false
        });
        return response.data;
      })
      .catch((error) => {
        dispatch({
          type: 'ERROR',
          error: error.response
        });
        dispatch({
          type: 'SET_LOADER',
          payload: false
        });
      });
  };
};

export const createSupplier = (payload) => {
  return async (dispatch) => {
    dispatch({
      type: 'SET_LOADER',
      payload: true
    });
    return await axios({
      method: 'POST',
      url: `${BACKOFFICE_SERVICE_URL + BACKOFFICE_SERVICE_ENDPOINT.ONBOARD_SUPPLIER}`,
      data: payload
    })
      .then((response) => {
        dispatch({
          type: 'SET_SUPPLIER_DETAILS',
          payload: response.data
        });
        dispatch({
          type: 'SET_LOADER',
          payload: false
        });
        return response.data;
      })
      .catch((error) => {
        dispatch({
          type: 'ERROR',
          error: error.response
        });
        dispatch({
          type: 'SET_LOADER',
          payload: false
        });
      });
  };
};

export const updateSupplier = (payload) => {
  return async (dispatch) => {
    dispatch({
      type: 'SET_LOADER',
      payload: true
    });
    return await axios({
      method: 'PATCH',
      url: `${BACKOFFICE_SERVICE_URL + BACKOFFICE_SERVICE_ENDPOINT.ONBOARD_SUPPLIER}`,
      data: payload
    })
      .then((response) => {
        dispatch({
          type: 'SET_SUPPLIER_DETAILS',
          payload: response.data
        });
        dispatch({
          type: 'SET_LOADER',
          payload: false
        });
        return response.data;
      })
      .catch((error) => {
        dispatch({
          type: 'ERROR',
          error: error.response
        });
        dispatch({
          type: 'SET_LOADER',
          payload: false
        });
      });
  };
};

export const deleteSupplierUser = (supplierUserMappingId) => {
  return async (dispatch) => {
    dispatch({
      type: 'SET_LOADER',
      payload: true
    });
    return await axios({
      method: 'DELETE',
      url: `${BACKOFFICE_SERVICE_URL + BACKOFFICE_SERVICE_ENDPOINT.ONBOARD_SUPPLIER}`,
      params: {
        supplierUserMappingId: supplierUserMappingId
      }
    })
      .then((response) => {
        dispatch({
          type: 'SET_LOADER',
          payload: false
        });
        return response.data;
      })
      .catch((error) => {
        dispatch({
          type: 'SET_LOADER',
          payload: false
        });
        throw error; 
      });
  };
};

